module.exports = __webpack_public_path__ + "static/media/logo.fcf96d3d.svg";